module.exports = __webpack_public_path__ + "img/gcdp_6.028f0ec2.jpg";